import React from "react";
import { navigateHome } from "./helpers/Tools";
import { useNavigate } from "react-router-dom";

 

export default function ErrorPage() {

      const navigate = useNavigate();

      return (
    <div className="success-ts-body"

    style={{
      backgroundImage: 'url("/assets/background.jpg")',
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      minHeight: "100vh",
    }}

    >
      <div className="success-ts-page">
        <header className="success-ts-header">
         <img src="/assets/RepublicaTransfer-logo.png"  class="republica-logo"
            onClick={() => navigate("/") }/>

        </header>

        <main className="success-ts-content">
          <div className="success-ts-card">
            <h1 className="success-ts-title">Whoops!</h1>            
            <div className="success-ts-name-row">
              <span className="success-ts-shipment-name">You took a wrong path.</span>
            </div>          
          </div>
        </main>
      </div>
    </div>
  );
}
